import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF5EE] hex-pattern flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="max-w-sm w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex justify-center" data-testid="admin-login-home-link"><Logo size={52} /></Link>
          <h1 className="mt-4 font-serif-display text-2xl font-bold text-[#2C221E]">Family Login</h1>
          <p className="mt-1 text-sm text-[#8C7A6B]">Manage the McGee's Bees shop</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E6D7C3] p-8 flex flex-col gap-5 shadow-lg" data-testid="admin-login-form">
          {error && (
            <p className="text-sm text-[#9A3412] bg-[#9A3412]/10 rounded-xl px-4 py-3" data-testid="admin-login-error">{error}</p>
          )}
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            data-testid="admin-email-input"
            className="w-full px-5 py-3.5 rounded-xl border border-[#E6D7C3] text-sm focus:outline-none focus:ring-2 focus:ring-[#D97706]"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            data-testid="admin-password-input"
            className="w-full px-5 py-3.5 rounded-xl border border-[#E6D7C3] text-sm focus:outline-none focus:ring-2 focus:ring-[#D97706]"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full py-3.5 rounded-full bg-[#D97706] hover:bg-[#B45309] text-white font-semibold text-sm transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
